/**
 * WPA类型
 * 1 - 图标型
 * 2 - 链接型
 * 3 - DOM型
 */
const KIND = {
    1: 1,
    2: 2,
    3: 3
};

/**
 * WPA通路类型
 * 1 - QQ接待
 * 3 - 公众号推广
 * 4 - 群推广
 * 5 - 员工推广
 * 7 - 网页接待
 * 8 - 企点接待
 */
const CATE = {
    1: 1,
    3: 3,
    4: 4,
    5: 5,
    7: 7,
    8: 8
};

/**
 * WPA使用场景
 * 0 - 网页样式
 * 1 - 公众号图文样式
 * 2 - 手机网页样式
 * 3 - 链接/二维码
 */
const SCENE = {
    0: 0,
    1: 1,
    2: 2,
    3: 3
};

/**
 * WPA部署位置
 * 0 - 挂载位置(默认)
 * 1 - 电脑网页
 * 2 - 手机网页
 * 3 - 线下物料
 * 4 - 短信邮件
 * 5 - 公众号图文
 * 6 - 其他
 */
const DEPLOY = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6
};

export default {
    2: {
        7: {
            10: {
                kind: KIND[2],
                cate: CATE[7],
                type: 10,
                scene: SCENE[3],
                required: ['role', 'deployList', 'openKfId'],
                role: ['roleWX'],
                defaults: {
                    deployList: [
                        {
                            deployTypeId: DEPLOY[0],
                            deployRemarks: '',
                            deployWebsite: ''
                        }
                    ]
                }
            }
        }
    }
};
